import { TThunkAction } from '../../types/redux';
import {
  fetchSaveRealtorReport,
  TSaveRealtorReportResponse,
  TSaveRealtorReportRequest,
} from '../../repositories/price-estimator/v2/save-realtor-report';

import { getAuthorName } from './utils';
import { setShareReportUrl, toggleReportStatus, toggleSaveReportError, toggleSaveReportLoading } from './actions';
import { selectMappedPreciseFilters } from '../../selectors/preciseFilters';
import { EReportStatus } from '../../constants/report';
import { BadRequestError } from '@cian/valuation-utils-component';

export function saveReportAction(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const state = getState();
    const {
      filters: { address, area, roomsCount },
      author: { firstName, lastName, cianUserId },
      comments: { mainComment },
      page: { dealType },
    } = state;

    const parameters = {
      address,
      area: area as number,
      roomsCount: roomsCount as TSaveRealtorReportRequest['roomsCount'],
      authorName: getAuthorName({
        firstName,
        lastName,
        cianUserId,
      }),
      comments: {
        main: mainComment,
      },
      dealType,
      filters: selectMappedPreciseFilters(state),
      similarOffersIds: [],
    } as TSaveRealtorReportRequest & { authorName: string };

    dispatch(toggleSaveReportLoading(true));
    dispatch(toggleSaveReportError(''));

    try {
      const res = (await fetchSaveRealtorReport({
        httpApi,
        parameters,
      })) as TSaveRealtorReportResponse;

      if (res.statusCode === 200) {
        dispatch(toggleReportStatus(EReportStatus.Share));
        dispatch(setShareReportUrl(res.response.url));

        return;
      }

      dispatch(toggleSaveReportError(res.response.message as string));

      throw new BadRequestError({
        domain: 'saveReportAction.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      logger.error(error, { message: 'Ошибка при сохранении отчета', parameters: JSON.stringify(parameters) });

      dispatch(toggleSaveReportError('Что-то пошло не так. Пожалуйста попробуйте позже'));
    } finally {
      dispatch(toggleSaveReportLoading(false));
    }
  };
}
